// @flow
import {Gauge} from "gaugeJS";
import $ from "../vendor/jquery";

/**
 * Usage:
 *  let g = new AngleChart(parentId, class, nominalInfo);
 *  g.setValue(v);
 */
class AngleChart {
    static angleChartLast = 0;
    /**
     *
     * @param {string} parentId Vanemelemendi Id, mille alla lisada
     * @param {string} className CSS klassi nimi, mis tuleb elemendile omistada
     * @param {NominalInfo} nominalInfo Nominaali info: [v, t1p, t1m, t2p, t2m], kus v - nominaalväärtus, t1p - ülemine 1. tolerants, t1m - alumine 1. tolerants, t2p - ülemine 2. tolerants, t2m - alumine 2. tolerants
     */
    constructor(parentId, className, nominalInfo) {
        AngleChart.angleChartLast++;
        this.chartId = AngleChart.angleChartLast;

        /**
         * @type {NominalInfo}
         */
        this.nominalInfo = nominalInfo;
        this.className = className;

        let placeholder = $("#"+parentId);
        placeholder.append(`<div class="${className}"><canvas id="angleChart-${this.chartId}" class="${className}-chart"></canvas><div class="${className}-value"><div id="angleChart-${this.chartId}-value"></div></div></div>`);
        let el = $(`#angleChart-${this.chartId}`).get(0);
        let absOffset = this.getAbsOffset();
        let v = nominalInfo[0];

        this.gaugeOpts = {
            angle: 0,
            lineWidth: 0.2,
            radiusScale: 0.75,
            highDpiSupport: true,
            limitMin: true,
            limitMax: true,
            pointer: {
                length: 0.6,
                strokeWidth: 0.03
            },

            staticLabels: {
                font: "12px sans-serif",
                labels: [(v - nominalInfo[4])/10, (v - nominalInfo[2])/10, v/10, (v + nominalInfo[1])/10, (v + nominalInfo[3])/10],
                color: "#000000",
                fractionDigits: 1
            },
            staticZones: [
                {strokeStyle: "rgb(255,0,0)",   min: (v - absOffset)/10,      max: (v - nominalInfo[4])/10},
                {strokeStyle: "rgb(255,128,0)", min: (v - nominalInfo[4])/10, max: (v - nominalInfo[2])/10},
                {strokeStyle: "rgb(0,255,0)",   min: (v - nominalInfo[2])/10, max: (v + nominalInfo[1])/10},
                {strokeStyle: "rgb(255,128,0)", min: (v + nominalInfo[1])/10, max: (v + nominalInfo[3])/10},
                {strokeStyle: "rgb(255,0,0)",   min: (v + nominalInfo[3])/10, max: (v + absOffset)/10}
            ]
        };
        this.gauge = new Gauge(el).setOptions(this.gaugeOpts);
        this.gauge.animationSpeed = 1;
        this.gauge.maxValue = (v + absOffset)/10;
        this.gauge.setMinValue((v - absOffset)/10);
    }

    getAbsOffset() {
        let maxOffset = Math.max(this.nominalInfo[3], this.nominalInfo[4]);
        // Suurendame max offseti täiendavalt 50%:
        return Math.round(maxOffset*150/100);
    }

    /**
     *
     * @param {number} value Gauge hetkeväärtuse seadmine
     */
    setValue(value) {
        let v = value / 10;
        this.gauge.set(v);
        $(`#angleChart-${this.chartId}-value`).text(v);
    }
}

export default AngleChart;
